// API 基础 URL 配置
// 开发环境 (localhost) 使用 Vite proxy (相对路径)
// 生产环境 (Cloudflare Pages) 指向 Worker

const isDev = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

export const API_BASE = isDev ? '' : 'https://neuro-duel-api.yanrong-test.workers.dev';

// 统一的 fetch 封装
export async function apiFetch(path: string, init?: RequestInit): Promise<Response> {
  return fetch(`${API_BASE}${path}`, {
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...init?.headers,
    },
  });
}
